import type { AxiosRequestConfig } from "axios";
import axios from "axios";

const baseURL = import.meta.env.VITE_API_URL;

// Définir un type pour la fonction de snackbar
type ShowSnackbarFn = (message: string, type: "success" | "error" | "info" | "warning") => void;

// Variable globale pour stocker la référence à la fonction
let showSnackbar: ShowSnackbarFn | null = null;

// Fonction pour enregistrer la fonction de snackbar
export const registerSnackbar = (fn: ShowSnackbarFn): void => {
  showSnackbar = fn;
};

export const HTTPClient = axios.create({ baseURL });

HTTPClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.message === "Network Error") {
      showSnackbar?.("Erreur de réseau. Si le problème persiste, contactez le support.", "error");
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 403) {
      try {
        showSnackbar?.("Vous êtes deconnecté. Veuillez-rafraichir la page.", "warning");
      } catch (e) {
        console.error(e);
      }
    }
    return Promise.reject(error);
  }
);

export const swrFetcher = (config: AxiosRequestConfig) =>
  HTTPClient.request(config).then((res) => res.data);
